import styled from "@emotion/styled";
import { Modal, Button } from "@xometry/xometry_loft";
import theme from "../../styles/theme";

export const EntryBase = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  :hover .grid-image,
  :focus .grid-image {
    transform: scale(1.075);
  }
`;

export const ImageWrapper = styled.div`
  display: inline-block;
  overflow: hidden;
  margin-bottom: 0.5rem;
`;

export const Image = styled.img`
  border-radius: 3px;
  width: 100%;
  vertical-align: middle;
  transition: all 0.25s;
`;
export const Title = styled.div`
  color: ${theme.colors.darkBlues[90]};
  font-size: ${theme.fontSizes[1]};
  line-height: ${theme.leading.normal};
  font-weight: ${theme.fontWeights.semibold};

  ${theme.largerThan.sm} {
    font-size: ${theme.fontSizes[2]};
  }
`;

export const Subtitle = styled.div`
  color: ${theme.colors.darkBlues[75]};
  font-size: ${theme.fontSizes[0]};
  line-height: ${theme.leading.normal};
`;

export const StyledModal = styled(Modal)<{}>`
  position: relative;
  cursor: initial;
  border-radius: 3px;
  max-width: 1104px !important;
  max-height: 80vh !important;
  padding: 60px 48px !important;
  margin: 0 20px !important;
  overflow: auto !important;
`;

export const ModalCloseButton = styled(Button)<{}>`
  position: absolute;
  top: 10px;
  right: 12px;
  padding: 10px 12px;

  &:focus {
    outline: 1px solid ${theme.colors.darkBlues[100]};
  }
`;

export const ModalContents = styled.div`
  display: flex;
  flex-direction: column;

  ${theme.largerThan.lg} {
    flex-direction: row;
  }
`;

export const ModalImage = styled.img`
  flex-basis: 40%;
  object-fit: cover;
  border-radius: 3px;
  max-width: 321px;

  ${theme.largerThan.sm} {
    min-height: 383px;
    max-width: 383px;
  }

  ${theme.largerThan.lg} {
    margin-right: 48px;
  }
`;

export const ModalText = styled.div`
  flex-basis: 60%;
  padding-top: 26px;
`;

export const ModalTitle = styled.h2`
  margin: 0 0 22px 0;
`;

export const ModalSubtitle = styled(Subtitle)`
  font-weight: ${theme.fontWeights.semibold};
`;

export const Description = styled.div`
  color: ${theme.colors.darkBlues[90]};
  font-size: ${theme.fontSizes[1]};
  line-height: ${theme.leading.normal};
`;
